import React from 'react';
import linksColumn from './links';
import SocialLinks from './SocialLinks';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';
import style from './style.scss'; //NOSONAR

const Navigation = () => {

    const clickLinkFooter = (action, tag) => {
        TagManagerService.footer(action, tag);
    }

    return (
        <section className={'footer-nav open'}>
            <nav className={'center'}>
                {linksColumn.map((item, i) => {
                    return (
                        <div className='footer-nav-col' key={i}>
                            <h3 className='footer-nav-title'> {item.title} </h3>
                            <ul className={'footer-nav-links'}>
                                {item.links.map((link) =>
                                    <li className='footer-nav-item' key={link.title.trim()} onClick={() => clickLinkFooter(item.title, link.title)}>
                                        <Link to={link.url} target={link.target || '_self'} className='footer-nav-link mobile-click'>{link.title}</Link>
                                    </li>
                                )}
                                {item.child && item.child.map((item, i) => 
                                    <div className='footer-nav-business-service' key={i}>
                                        <h3 className='footer-nav-title'> {item.title} </h3>
                                        <ul className={'footer-nav-links'}>
                                            {item.links.map((link) =>
                                                <li className='footer-nav-item' key={link.title.trim()} onClick={() => clickLinkFooter(item.title, link.title)}>
                                                    <Link to={link.url} target={link.target || '_self'} className='footer-nav-link mobile-click'>{link.title}</Link>
                                                </li>
                                            )}
                                        </ul>
                                    </div>)}
                            </ul>
                        </div>)
                })
                }
                <div className='footer-puntos-cencosud'>
                    <SocialLinks />
                </div>
            </nav>
            <div className='footer-contact'>
                <SocialLinks />
                <div className='footer-contact-number'>
                    <a href="tel:600 400 3000" className='footer-phone-text mobile-click'>600 400 3000</a>
                </div>
            </div>
        </section>
    )
}

export default Navigation;
